import axios from "axios";
import config from "app/api/axiosConfig";

export default (id: string, token: string) =>
	axios.delete(`${process.env.REACT_APP_GALLERY_HOST}/gallery/albums/${id}`, config(token))
